// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"b40c640e","552":"b40c640e"}[chunkId] + ".chunk.css";
};